import { ActivityLog } from "./activity_log";

export class ActivityLogs extends Array<ActivityLog> {
  constructor(logs?: ActivityLog[]) {
    super();
    if (logs instanceof Array) logs.forEach((log) => this.push(log));
  }
}
